var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4h-1.551c-.252-2.244-2.139-4-4.449-4h-3C8.19 0 6.303 1.756 6.051 4H4.5A4.505 4.505 0 0 0 0 8.5v11C0 21.981 2.019 24 4.5 24h15c2.481 0 4.5-2.019 4.5-4.5v-11C24 6.019 21.981 4 19.5 4m-9-3h3c1.758 0 3.204 1.308 3.449 3H7.051c.245-1.692 1.691-3 3.449-3m-6 4h15C21.43 5 23 6.57 23 8.5V12H1V8.5C1 6.57 2.57 5 4.5 5m15 18h-15C2.57 23 1 21.43 1 19.5V13h10.5v1.5a.5.5 0 0 0 1 0V13H23v6.5c0 1.93-1.57 3.5-3.5 3.5"
  })));
};
export default SvgBriefcase;